export default "<title>{{title}}</title>\r\n<router-outlet></router-outlet>\r\n"